const iconList = null

const contextMenu = []

export function WSFile(arl, folder) {

    this.name = arl?.getName()
    this.folder = folder          
    this.arl = arl  
    this.is = {
        highLighted: false
    }                
}
WSFile.prototype = {

    getFileSystem() {
        return this.folder?.getFileSystem?.() ?? null
    },

    isReadOnly() {
        return this.arl?.canWrite?.() === false || this.getFileSystem()?.readOnly === true
    },


    getPath() {
        let path = this.folder.getPath()
        return path.at(-1) == '/' ? path + this.name : path + '/' + this.name
    },

    getExt() {
        let start = this.name.lastIndexOf('.')
        return start < 0 ? "any" : this.name.slice(start+1)
    },

    getSplit(path)  {

        // we only need the fileName
        let slash = path.lastIndexOf('/')
        const fileName = slash > 0 ? path.slice(slash+1) : path

        let p1 = fileName.lastIndexOf('.')
        let p2 = fileName.lastIndexOf('.', p1-1)
        
        return {
            name: p2 > 0 ? fileName.slice(0,p2) : (p1 > 0 ? fileName.slice(0,p1) : fileName),
            ext: p2 > 0 ? fileName.slice(p2) : (p1 > 0 ? fileName.slice(p1) : null)
        }
    },

    // splits 'name.ext' in 'name' and '.ext' and 'name.kind.ext' if 'file' '.kind' and '.ext'
    split(path)  {

        // we only need the fileName
        let slash = path.lastIndexOf('/')
        const fileName = slash > 0 ? path.slice(slash+1) : path

        let p1 = fileName.lastIndexOf('.')
        let p2 = fileName.lastIndexOf('.', p1-1)
        
        return {
            name:   p2 > 0 ? fileName.slice(0,p2) : (p1 > 0 ? fileName.slice(0,p1) : fileName),
            kind:   p2 > 0 ? fileName.slice(p2,p1) : null,
            ext:    p1 > 0 ? fileName.slice(p1) : null
        }
    },

    getIcon() {
        const ext = this.split(this.name).ext
        //const ext = this.getSplit(this.name).ext
        if (ext == '.blu') return 'account_tree' 
        if (ext == ".viz") return "data_object"
        if (ext == ".prf") return "data_object"
        if (ext == '.js' || ext == 'msj') return 'electric_bolt' 
        if (ext == '.json') return 'data_object'
        if (ext == '.html') return 'code'
        if (ext == '.css') return  'tag'
        return 'description'
    },

    getFileClass() {
        const ext = this.split(this.name).ext

        if (ext == ".blu") return "model-file"
        if (ext == ".viz") return "vmblu-file"
        if (ext == ".prf") return "vmblu-file"

        if (ext == ".js") return "js-file"
        return "other-file"
    },

    rename(newName) {

        if (this.isReadOnly()) return

        // no change..
        if (newName === this.name) return

        // check the name - no duplicates in the same folder
        if (!this.folder.checkName(newName)) return

        // update folder
        this.arl.rename(newName)
        .then( ok =>  {

            // the error has been given already
            if (!ok) return

            // get the old name
            const oldName = this.name

            // change the name and ..
            this.name = newName
            
            // ..update the file/folder div
            this.folder.getDrawer().update()

            // ..maybe someone needs to know that we renamed a file...
            tx.send('file.renamed',{oldName,newName})
        })
        .catch( error => console.log(error))
    },

    confirmDelete(e) {
        showMessage("Confirm delete file", `Delete file  ${this.name}  ?`, (e) => this.remove() )
    },

    remove(){

        if (this.isReadOnly()) return

        // remove the file at the server side
        this.arl?.remove()
        .then( () => {

            // add to the the folder
            this.folder.ejectFile(this)

            // update the drawer
            this.folder.getDrawer().update()

            // if there is a filetab open for the file - close it
            tx.send('file.deleted',this.arl)
        })
        .catch( error => console.error(error))
    },
}
